module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_CISTUSINCANUS.3ded73c9.png";